import "./DaWrongDevice.css";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";

import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";

const DaWrongDevice = () => {
  const { search } = useLocation();
  const incomingQueryParams = new URLSearchParams(search);
  const clientId = incomingQueryParams.get("client_id");

  useEffect(() => {
    if (clientId) {
      localStorage.setItem("da-client-id", clientId);
    }
  }, [clientId]);

  return (
    <DaPageWrapper
      wrapperClass="da-wrong-device da-page-wrapper"
      iconType="access_denied"
      title={<Translate tKey={T_KEYS.DA.WRONG_DEVICE.TITLE} />}
    >
      <p className="da-wrong-device-message da-wrong-device-intro">
        <Translate tKey={T_KEYS.PASSWORD_COOKIE_MISSING_OR_EXPIRED_INTRO} />
      </p>
      <p className="da-wrong-device-message da-wrong-device-followup">
        <Translate tKey={T_KEYS.PASSWORD_COOKIE_MISSING_OR_EXPIRED_FOLLOWUP} />
      </p>
    </DaPageWrapper>
  );
};

export { DaWrongDevice };
